import React, { useRef } from 'react';
import { FaChartBar } from 'react-icons/fa';
import { HiCheck, HiChevronRight } from "react-icons/hi";
import Avatar1 from '../Images/s1.png';
import Avatar2 from '../Images/beam1.png';
import Avatar3 from '../Images/beam2.png';
import Avatar4 from '../Images/plate5.png';
import Avatar5 from '../Images/plate7.png';
import Hdpc1 from '../Images/hdpc1.png';
import Hdpc2 from '../Images/hdpc2.png';
import Hdpc3 from '../Images/hdpc3.png';
import Hdpc4 from '../Images/hdpc4.png';
import Flange1 from '../Images/flanges1.png';
import Flange2 from '../Images/flanges2.png';
import Flange3 from '../Images/flanges3.png';
import Flange4 from '../Images/planges4.png';
import Logis1 from '../Images/h1.png';
import Logis2 from '../Images/A1.png';
import Logis3 from '../Images/h3.png';
import Logis4 from '../Images/h4.png';
import Footer from '../components/Footer';

const servicesData = [
  {
    id: 1,
    title: "Steel Products",
    description:
      "We supply a comprehensive range of high-quality steel products for oil & gas, construction, and industrial applications.",
    image: Avatar2,
    points: [
      // "Pipes (Seamless & Welded)",
      "Bars (Round, Flat & Square)",
      "Plates (Mild Steel & Stainless Steel)",
      "Angles & Sections",
      "Rods & Mesh",
      "Tubes & Beams",
    ],
    projectImages: [
      Avatar3,
      Avatar4,
      Avatar5
    ]
  },
  {
    id: 2,
    title: "HDPE Products",
    description:
      "We procure and supply a full range of HDPE pipes and fittings suitable for water, gas, and industrial piping systems.",
    image: Hdpc1,
    points: [
      "HDPE Pipes",
      "Couplers",
      "Elbows",
      "Tees",
      "Reducers",
      "And More Fittings"
    ],
    projectImages: [
      Hdpc2,
      Hdpc3,
      Hdpc4
    ]
  },
  {
    id: 3,
    title: "Procurements of Flanges",
    description:
      "We procure and supply a wide variety of industrial-grade flanges for oil & gas, petrochemical, and construction applications, ensuring secure and leak-proof pipe connections.",
    image: Flange1,
    points: [
      "Weld Neck Flanges",
      "Slip-On Flanges",
      "Blind Flanges",
      "Socket Weld Flanges",
      "Threaded Flanges",
      "Lap Joint Flanges",
      "Reducing Flanges",
    ],
    projectImages: [
      Flange2,
      Flange3,
      Flange4

    ]
  },
  {
    id: 4,
    title: "Procurement & Logistics",
    description:
      "We offer end-to-end procurement, logistics, supply chain, and consultancy services to keep your projects running smoothly and cost-effectively.",
    image: Logis1,
    points: [
      "Procurement Services",
      "Logistics & Shipping",
      "Supply Chain Management",
      "Consultancy Services"
    ],
    projectImages: [
      Logis2,
      Logis3,
      Logis4
    ]
  }
];

const ServicesSection = () => {
  const scrollRefs = useRef([]);

  const scroll = (index, direction) => {
    const el = scrollRefs.current[index];
    if (el) {
      el.scrollBy({
        left: direction === "left" ? -300 : 300,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      {/* HERO */}
      <section className="about_hero">
        <div className="textCarrrier">
          <div className="mission_left">
            <span className="section_label wow animate__animated animate__fadeInUp" data-wow-delay="1s">
              + Reliable procurement since 2006.
            </span>
            <h1 className="wow animate__animated animate__fadeInUp" data-wow-delay="1.3s">Services</h1>
            <p className="wow animate__animated animate__fadeInUp" data-wow-delay="1.5s">
              Lenpec Global Concept Limited delivers trusted procurement,
              supply, and technical services for oil & gas, construction,
              and industrial projects.
            </p>
          </div>
        </div>
        <div className="imgcarrier wow animate__animated animate__fadeInUp" data-wow-delay="1.9s">
          <img src={Avatar1} alt="Services" />
        </div>
      </section>

      <div className="hero-divider" />

      {/* SERVICES INTRO */}
      <div className="services-wrapper">
        <section className="services-description">
          <div className="description-container">
            <h2 className="description-title wow animate__animated animate__fadeInUp" data-wow-delay="1s">
              We provide end-to-end procurement solutions for energy and
              infrastructure projects.
              <FaChartBar className="inline-icon" />
              <span className="highlighted-text">
                Our team sources materials directly from OEMs and trusted
                manufacturers, ensuring quality, compliance, and timely delivery.
              </span>
            </h2>
          </div>
        </section>
      </div>

      <div className="hero-divider" />

      {/* DISPLAY SERVICES */}
      <div className="services-wrapper">
        {servicesData.map((service, index) => (
          <section className="va-wrapper" key={index}>
            <div className="va-card">

              {/* Left Image */}
              <div className="va-image">
                <img
                  src={service.image}
                  alt={service.title}
                  className="wow animate__animated animate__fadeInUp"
                  data-wow-delay="1s"
                />
              </div>

              {/* Right Content */}
              <div className="va-text">
                <h2 className="wow animate__animated animate__fadeInUp" data-wow-delay="1s">
                  {service.title}
                </h2>
                <p className="wow animate__animated animate__fadeInUp" data-wow-delay="1.3s">
                  {service.description}
                </p>
                <ul>
                  {service.points.map((point, idx) => (
                    <li key={idx} className="wow animate__animated animate__fadeInUp" data-wow-delay="1.6s">
                      <HiCheck /> {point}
                    </li>
                  ))}
                </ul>
                <button
                  className="va-btn wow animate__animated animate__fadeInUp"
                  data-wow-delay="1.8s"
                  onClick={() => scroll(index, "right")}
                >
                  <HiChevronRight />
                </button>
              </div>
            </div>

            <div className="project_img_carrier wow animate__animated animate__fadeInUp" data-wow-delay="1.3s">
              <div
                className="project_container"
                ref={(el) => (scrollRefs.current[index] = el)}
              >
                {service.projectImages.map((img, i) => (
                  <div className="project_work_items" key={i}>
                    <img src={img} alt={`${service.title}-project-${i}`} />
                  </div>
                ))}
              </div>
            </div>

            <div className="va-divider" />

          </section>
        ))}
      </div>

      <Footer />
    </>
  );
};

export default ServicesSection;